var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path7, _rect4, _path8, _rect5, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavannahThumbnailContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline-black",
    d: "M101 72V91C101 96.5228 96.5228 101 91 101H28.5C28.5 97.8 37.3 84 38.45 82.5C44.315 79 54.63 81.5 68.085 82.5C78.849 83.3 93.41 75.8333 101 72Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M96.846 58.0312C96.6973 56.9367 95.6894 56.17 94.5949 56.3187L93.2436 56.5023C92.1491 56.651 91.3823 57.6588 91.531 58.7533L91.5943 59.2189C91.743 60.3134 90.9763 61.3212 89.8818 61.4699L11.4639 72.1243C10.3694 72.273 9.60269 73.2809 9.7514 74.3754L10.0554 76.6125C10.2041 77.7071 11.2119 78.4738 12.3064 78.3251L96.0392 66.9485C97.1337 66.7998 97.9004 65.792 97.7517 64.6975L96.846 58.0312Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline-black",
    d: "M51.6602 24.2609L54.3176 23.8998L64.7741 47.74L62.1166 48.101L51.6602 24.2609Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-part",
    d: "M29.3511 32.7048L54.1541 29.3349L60.8699 45.5638L31.6378 49.5354L29.3511 32.7048Z",
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-character-part",
    x: 9.93994,
    y: 42.5597,
    width: 16.9852,
    height: 10.7275,
    rx: 2,
    transform: "rotate(-7.73724 9.93994 42.5597)",
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline-black",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6133 28.7173C30.3539 26.8076 27.8091 26.3336 26.8795 28.0219L15.0724 49.4673C14.2798 50.9068 15.4653 52.6349 17.0937 52.4137L19.7397 52.0542C19.2321 51.4736 19.0566 50.6096 19.4644 49.8179L24.7941 39.4718C25.6896 37.7335 28.2906 38.1808 28.5538 40.1184L29.8374 49.5661C29.8925 49.9713 29.822 50.3646 29.656 50.7069L31.5476 50.4499C32.6421 50.3012 33.4088 49.2933 33.2601 48.1988L30.6133 28.7173Z",
    fill: "#22262A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline-black",
    d: "M10.1653 57.4988C9.79357 54.7625 11.7104 52.2429 14.4467 51.8712L86.9191 42.0245C89.6554 41.6528 92.175 43.5696 92.5468 46.3059L94.6418 61.7253L12.2603 72.9182L10.1653 57.4988Z",
    fill: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-innerline-black",
    cx: 26.9152,
    cy: 74.5359,
    r: 13.8034,
    transform: "rotate(-7.73724 26.9152 74.5359)",
    fill: "#1E1E1E",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-innerline-black",
    cx: 78.2927,
    cy: 67.5553,
    r: 13.8034,
    transform: "rotate(-7.73724 78.2927 67.5553)",
    fill: "#1E1E1E",
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-outline-white",
    cx: 26.9146,
    cy: 74.536,
    r: 7.15168,
    transform: "rotate(-7.73724 26.9146 74.536)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-outline-white",
    cx: 78.2921,
    cy: 67.5554,
    r: 7.15168,
    transform: "rotate(-7.73724 78.2921 67.5554)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-outline-black",
    cx: 26.915,
    cy: 74.5359,
    r: 5.36376,
    transform: "rotate(-7.73724 26.915 74.5359)",
    fill: "#1E1E1E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-character-outline-black",
    cx: 78.2924,
    cy: 67.5553,
    r: 5.36376,
    transform: "rotate(-7.73724 78.2924 67.5553)",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M94.1128 48.2646C94.3056 49.6832 94.2364 50.977 93.987 51.9152C93.8621 52.3855 93.6984 52.7416 93.5209 52.9786C93.3449 53.2136 93.1817 53.2996 93.0485 53.3177C92.9153 53.3358 92.7351 53.2964 92.5028 53.1169C92.2685 52.9359 92.0158 52.6363 91.7698 52.2165C91.2792 51.3788 90.8673 50.1504 90.6746 48.7317C90.4819 47.3131 90.551 46.0194 90.8004 45.0811C90.9254 44.6109 91.089 44.2547 91.2665 44.0178C91.4425 43.7828 91.6057 43.6968 91.7389 43.6787C91.8721 43.6606 92.0523 43.6999 92.2846 43.8795C92.5189 44.0605 92.7717 44.36 93.0176 44.7799C93.5082 45.6176 93.9201 46.846 94.1128 48.2646Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-character-outline-black",
    x: 5.30371,
    y: 54.9178,
    width: 4.4698,
    height: 16.9852,
    rx: 2,
    transform: "rotate(-7.73724 5.30371 54.9178)",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-innerline-white",
    d: "M31.2557 23.8755C31.5343 25.9264 30.455 27.5394 29.125 27.7201C27.795 27.9008 26.3245 26.6343 26.0458 24.5833C25.7672 22.5323 26.8465 20.9193 28.1765 20.7386C29.5065 20.5579 30.977 21.8245 31.2557 23.8755Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-character-outline-white",
    x: 39.9712,
    y: 51.1099,
    width: 8.04564,
    height: 2.68188,
    rx: 1.34094,
    transform: "rotate(-7.73724 39.9712 51.1099)",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-character-outline-black",
    d: "M1 82V91C1 96.5228 5.47715 101 11 101H91C91 97.8 87.6667 94 86 92.5C77.5 89 74 91.5 54.5 92.5C38.9 93.3 12 85.8333 1 82Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavannahThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SavannahThumbnail-contrast.6a39618c4785ec7bed6e2ab4f4b8b951.svg";